var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBackForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.91421 11.0001L10.8536 7.06074C11.0488 6.86547 11.0488 6.54889 10.8536 6.35363L10.1464 5.64652C9.95118 5.45126 9.6346 5.45126 9.43934 5.64652L3.43934 11.6465C3.24408 11.8418 3.24408 12.1584 3.43934 12.3536L9.43934 18.3536C9.6346 18.5489 9.95118 18.5489 10.1464 18.3536L10.8536 17.6465C11.0488 17.4513 11.0488 17.1347 10.8536 16.9394L6.91421 13.0001L20 13.0001C20.2761 13.0001 20.5 12.7762 20.5 12.5001L20.5 11.5001C20.5 11.2239 20.2761 11.0001 20 11.0001L6.91421 11.0001Z",
    fill: "#002CFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBackForward);
export default __webpack_public_path__ + "static/media/iconBackForward.7e89d88107171786d93428bbc861edfc.svg";
export { ForwardRef as ReactComponent };